import { ICopyable } from '../core/copyable.interface';
import { IIdentifiable } from '../core/identifiable.interface';
import { ActionType } from '../enums/action-type';
import { SeverityLevel } from '../enums/severity-level';

/**
 * Represente un document d'un dossier
 */
export class History implements ICopyable<History>, IIdentifiable {
    _id: any;

    get id(): any {
        return this._id;
    }

    set id(value: any) {
        this._id = value;
    }

    userId: string;

    userName: string;

    folderId: string;

    date: Date;

    type: ActionType;

    text: string;

    severityLevel: SeverityLevel;

    public createCopy(): History {
        const instance = new History();
        instance.id = this.id;
        instance.userId = this.userId;
        instance.userName = this.userName;
        instance.folderId = this.folderId;
        instance.date = this.date;
        instance.type = this.type;
        instance.text = this.text;
        instance.severityLevel = this.severityLevel;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.userId = other.userId;
        this.userName = other.userName;
        this.folderId = other.folderId;
        this.date = other.date;
        this.type = other.type;
        this.text = other.text;
        this.severityLevel = other.severityLevel;
    }

    /**
     * Retourne une instance de History à partir d'une instance de any.
     * @param other : Instance de any.
     * @returns : Instance de History.
     */
    public static from(other: any) {
        if (!!other) {
            const instance = new History();

            instance.id = other.id;
            instance.userId = other.userId;
            instance.userName = other.user.displayName;
            instance.folderId = other.folderId;
            instance.date = other.date;
            instance.type = other.action;
            instance.text = other.text;
            instance.severityLevel = other.severityLevel;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de History à partir d'un tableau d'instances de any.
     * @param other : Tableau d'instances de any.
     * @returns : Tableau d'instances de History.
     */
    public static fromArray(others: any[]) {
        if (!!others) {
            let histories: History[] = [];

            others.forEach((x) => {
                const history = History.from(x);
                histories.push(history);
            });

            return histories;
        } else {
            return null;
        }
    }
}
